import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const salesChannelsService = {
    getSalesChannels: async (params) => {
      const response = await authInstance
        .get(`${url}/salesChannels/list?` + new URLSearchParams(filterParams(params)))
        .then(async (response) => {
          return response;
        })
        .catch(function (error) {
          console.log('error', error);
          error.data = [];
          return error;
        });
      return response;
    },
      updateSalesChannel: async (salesChannelId, data) => {
        const response = await authInstance
          .put(`${url}/salesChannels/${salesChannelId}/update`, data)
          .then(async (response) => {
            return response;
          })
          .catch(function (error) {
            error.data = [];
            return error;
          });
        return response;
      },
      getSalesChannelsByIds: async ({ offset, limit, channelsIds, description }) => {
        const body = { offset, limit, channelsIds };
        if (description) body.description = description;
        const response = await authInstance
          .post(`${url}/salesChannels/list`, body)
          .then(async (response) => {
            return response;
          })
          .catch(function (error) {
            console.log('error', error);
            error.data = [];
            return error;
          });
        return response;
      },

      createSalesChannel: async (data) => {
        const response = await authInstance
          .post(`${url}/salesChannels/create`, data)
          .then(async (response) => {
            return response;
          })
          .catch(function (error) {
            error.data = [];
            return error;
          });
        return response;
      },
};
